import { Stack } from "@mui/material";
import React from "react";
import CardsScrollTest from "./CardsScrollTest";
import MainSecion3Backup from "./MainSecion3Backup";
import MainSecion3Backup2 from "./MainSecion3Backup2";
import MainSection3Test from "./MainSection3Test";
import MainCard from "../../CardStackScroll/MainCard";
import grid from "./Grid103.webp";
import MainCardMobile from "../../CardStackScroll/MainCardMobile";

const StackScroll = () => {
  return (
    <Stack
      sx={{
        // border: "2px solid red",
        backgroundImage: `url(${grid})`, // 👈 image path
        backgroundSize: "contain",     // cover entire area
        backgroundPosition: "center", // center the image

        // backgroundRepeat: "no-repeat", // prevent repeating
        }}

      
    >
      <MainSecion3Backup />
      {/* <CardsScrollTest /> */}
      {/* <MainSection3Test /> */}
      <MainCard />
      <MainCardMobile />
      {/* <MainSecion3Backup2 /> */}
    </Stack>
  );
};

export default StackScroll;
